const STATUS_READ = 'read';
const STATUS_RECEIVED = 'received';
const STATUS_DELIVERED = 'delivered';
const STATUS_UNDELIVERED = 'undelivered';
const STATUS_FAILED = 'failed';
const STATUS_SENDING = 'sending';
const STATUS_SENT = 'sent';
const STATUS_TEMPORARY_FAIL = 'temporary-fail';
const STATUS_UNREAD = 'unread';

const STATUSES = [
  STATUS_READ,
  STATUS_RECEIVED,
  STATUS_DELIVERED,
  STATUS_UNDELIVERED,
  STATUS_FAILED,
  STATUS_SENDING,
  STATUS_SENT,
  STATUS_TEMPORARY_FAIL,
  STATUS_UNREAD,
];

module.exports = {
  STATUS_READ,
  STATUS_RECEIVED,
  STATUS_DELIVERED,
  STATUS_UNDELIVERED,
  STATUS_FAILED,
  STATUS_SENDING,
  STATUS_SENT,
  STATUS_TEMPORARY_FAIL,
  STATUS_UNREAD,
  STATUSES,
};
